module.exports = __webpack_public_path__ + "img/hernando-de-soto.5bff3e0e.png";